<template>
  <div class="my-2">
    <ul
      v-if="info?.bulletpoints"
      class="list-inside list-disc"
    >
      <li
        v-for="item in info.bulletpoints"
        :key="item"
        class="text-base"
      >
        {{ item }}
      </li>
    </ul>
    <div
      v-if="description"
      class="mt-4 text-sm text-neutral-600"
      v-html="description"
    />
    <div
      v-if="seals.length"
      class="my-6 flex flex-wrap gap-4"
    >
      <template v-for="seal in seals">
        <NuxtLink
          v-if="seal.link"
          :key="`link-${seal.label}`"
          :to="seal.link"
        >
          <NuxtImg
            class="h-28"
            :height="110"
            :src="seal.url"
            :alt="$t('Seals')"
          />
        </NuxtLink>
        <NuxtImg
          v-else
          :key="`img-${seal.label}`"
          class="h-28"
          :height="110"
          :src="seal.url"
          :alt="$t('Seals')"
        />
      </template>
    </div>
    <template v-if="productNumber">
      <h2 class="mt-6 text-lg">
        {{ $t('Product number') }}
      </h2>
      <p class="text-base">
        {{ productNumber }}
      </p>
    </template>
    <template v-if="info?.material?.length">
      <p class="mt-6 text-lg font-bold">
        {{ $t('Material') }}
      </p>
      <ul class="list-none">
        <li
          v-for="item in info.material"
          :key="item"
        >
          {{ item }}
        </li>
      </ul>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { TAttributes } from '../types/product';
import { useSSR } from '~/composables/useSSR/useSSR';
import { useBFF } from '~/composables/useBFF/useBFF';

interface Props {
  info?: TAttributes;
  description?: string;
  productNumber: string | undefined;
}

const props = defineProps<Props>();
const seals = ref<Record<string, string>[]>([]);
const { $magnolia } = useBFF();
const { onSSR } = useSSR();

const handleSeals = async () => {
  try {
    seals.value = props.info?.seals ?? [];
    seals.value?.map(async (seal) => {
      const link = `/Certificates/${seal.label}`;
      const { data: content } = await $magnolia.fetchContent(link);
      if (content?.area1) {
        seal.link = link;
      }
    });
  }
  catch {
    // swallow error to avoid breaking the page
  }
};

onSSR(async () => {
  await handleSeals();
});
</script>
